import { Paper } from '@mantine/core';
import { Route, Switch } from 'wouter';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { OFFER_LIST_PERMISSIONS } from '@/models/permissions';
import OfferHubPage from './OfferHubPage';
import OfferListPage from './OfferListPage';

export default function OffersPage() {
  return (
    <Paper p="md" h="100%">
      <Switch>
        <Route path="/:id/:tab?" component={OfferHubPage} />
        <Route path="/">
          <ProtectedRoute
            component={OfferListPage}
            permissions={OFFER_LIST_PERMISSIONS}
          />
        </Route>
      </Switch>
    </Paper>
  );
}
